import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import NotificationsHistory from '../components/notifications/NotificationsHistory';

const NotificationsPage: React.FC = () => {
  const { darkMode } = useTheme();
  
  return (
    <div className={`container mx-auto p-4 ${darkMode ? 'bg-gray-900 text-gray-100' : 'bg-white text-gray-900'}`}>
      <h1 className="text-2xl font-bold mb-6">Notification History</h1>
      <div className={`p-6 rounded-lg shadow-md ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>
        <NotificationsHistory maxHeight="calc(100vh - 250px)" />
      </div>
    </div>
  );
};

export default NotificationsPage;
